import Footer from "components/VerticalLayout/Footer";
import React from "react";
import { Container, Card } from "reactstrap";

const Privacypolicy = () => {
    return (
        <React.Fragment>
            <div
                style={{
                    backgroundColor: "#121212",
                    color: "#fff",
                    minHeight: "100vh",
                    padding: "50px 20px",
                }}
            >
                <Container>
                    <br />
                    <br />
                    <br />
                    <h1 className="text-center mb-4">Privacy Policy</h1>
                    <Card
                        className="p-4 shadow-sm"
                        style={{ backgroundColor: "#1e1e1e", color: "#fff" }}
                    >
                        <p>
                            This Privacy Policy governs the manner in which{" "}
                            <strong>aiinrealestate.in</strong> ("we", "us", or "our") collects,
                            uses, maintains, and discloses information collected from users
                            (each, a "User") of the aiinrealestate.in website ("Site"). This
                            policy applies to the Site and all services offered by{" "}
                            <strong>aiinrealestate.in</strong>.
                        </p>

                        <h5>1. Personal Identification Information</h5>
                        <p>
                            We may collect personal identification information from Users in a
                            variety of ways, including, but not limited to, when Users visit
                            our site, register on the site, fill out a form, and in connection
                            with other activities, services, features, or resources we make
                            available on our Site. Users may be asked for, as appropriate,
                            name, email address, mailing address, phone number, and details of
                            their property or property requirements. We will collect personal
                            identification information from Users only if they voluntarily
                            submit such information to us. Users can always refuse to supply
                            personally identification information, except that it may prevent
                            them from engaging in certain Site-related activities.
                        </p>

                        <h5>2. Non-Personal Identification Information</h5>
                        <p>
                            We may collect non-personal identification information about Users
                            whenever they interact with our Site. This may include the browser
                            name, the type of computer, and technical information about a
                            User’s means of connection to our Site, such as the operating
                            system and the Internet service providers utilized and other
                            similar information.
                        </p>

                        <h5>3. Web Browser Cookies</h5>
                        <p>
                            Our Site may use "cookies" to enhance the User experience. A
                            User's web browser places cookies on their hard drive for
                            record-keeping purposes and sometimes to track information about
                            them. Users may choose to set their web browser to refuse cookies
                            or to alert them when cookies are being sent. If they do so, note
                            that some parts of the Site may not function properly.
                        </p>

                        <h5>4. How We Use Collected Information</h5>
                        <p>
                            <strong>aiinrealestate.in</strong> collects and uses Users’
                            personal information for the following purposes:
                        </p>
                        <ul>
                            <li>
                                <strong>To improve customer service:</strong> Your information
                                helps us to more effectively respond to your customer service
                                requests and support needs.
                            </li>
                            <li>
                                <strong>To personalize user experience:</strong> We may use
                                information in the aggregate to understand how our Users as a
                                group use the services and resources provided on our Site.
                            </li>
                            <li>
                                <strong>To process transactions:</strong> We may use the
                                information Users provide about themselves when placing an order
                                or inquiry only to provide service to that order. We do not share
                                this information with outside parties except to the extent
                                necessary to provide the service.
                            </li>
                            <li>
                                <strong>To send periodic emails:</strong> We may use the email
                                address to send User information and updates pertaining to their
                                inquiries. It may also be used to respond to their inquiries,
                                questions, and/or other requests. If a User decides to opt-in to
                                our mailing list, they will receive emails that may include
                                company news, updates, related product or service information,
                                etc. If at any time the User would like to unsubscribe, we
                                include detailed unsubscribe instructions at the bottom of each
                                email.
                            </li>
                        </ul>

                        <h5>5. How We Protect Your Information</h5>
                        <p>
                            We adopt appropriate data collection, storage, and processing
                            practices and security measures to protect against unauthorized
                            access, alteration, disclosure, or destruction of your personal
                            information, username, password, transaction information, and data
                            stored on our Site.
                        </p>

                        <h5>6. Sharing Your Personal Information</h5>
                        <p>
                            We do not sell, trade, or rent Users’ personal identification
                            information to others. We may share generic aggregated demographic
                            information not linked to any personal identification information
                            regarding visitors and users with our business partners, trusted
                            affiliates, and advertisers for the purposes outlined above. We may
                            use third-party service providers to help us operate our business
                            and the Site or administer activities on our behalf, such as
                            sending out newsletters or surveys. We may share your information
                            with these third parties for those limited purposes.
                        </p>

                        <h5>7. Compliance with Laws</h5>
                        <p>
                            This Privacy Policy is governed by and shall be construed in
                            accordance with the laws of India, including the Information
                            Technology Act, 2000 and its rules.
                        </p>

                        <h5>8. Changes to this Privacy Policy</h5>
                        <p>
                            <strong>aiinrealestate.in</strong> has the discretion to update
                            this privacy policy at any time. When we do, we will post a
                            notification on the main page of our Site and revise the updated
                            date at the bottom of this page. We encourage Users to frequently
                            check this page for any changes to stay informed about how we are
                            helping to protect the personal information we collect. You
                            acknowledge and agree that it is your responsibility to review this
                            privacy policy periodically and become aware of modifications.
                        </p>

                        <h5>9. Your Acceptance of These Terms</h5>
                        <p>
                            By using this Site, you signify your acceptance of this policy. If
                            you do not agree to this policy, please do not use our Site. Your
                            continued use of the Site following the posting of changes to this
                            policy will be deemed your acceptance of those changes.
                        </p>
                    </Card>
                </Container>
            </div>

            {/* Footer */}
            <Footer />
        </React.Fragment>
    );
};

export default Privacypolicy;
